import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { AuthGate, AuthServiceProvider, withAuthState } from '@trp-ta-nitro/auth-react';

import { GLOBALS } from 'services/globals';
import { ConfigContext } from 'components/config/ConfigProvider';
import ErrorBoundary from 'components/shared/ErrorBoundary/ErrorBoundary';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import { getAccounts } from 'state/account/AccountSelectors';
import SessionTimer from '../SessionTimer/SessionTimer';

const SecureAuth = ({
  children,
  isCustomerWebView = true
}) => {
  return (
    <ConfigContext.Consumer>
    {({ config }) => {
        const { apiKey, otelContext } = config;

        if (isEmpty(config)) {
            return <PageLoadingSpinner name="Configuration..." />;
        }

        const options = {
            apiKey,
            types: {
                external: {},
                internal: {
                    customerWebViewEnabled: isCustomerWebView
                }
            }
        };

        const aamSdurl =
            GLOBALS.AAM_UI_EXTERNAL_BASE_URL + GLOBALS.AAM_UI_TRP_APP_CONTEXT;
        const aamPdurl = '/clx-tk/token-exchange/redirect/default%3f';

        // eslint-disable-next-line no-undef
        if (process.env.REACT_APP_MOCK === 'true') {
        options.types.external.authenticateUrl = `https://localhost.troweprice.com:8080${GLOBALS.AAM_UI_TRP_APP_CONTEXT}/api/clx-tk/token-exchange/service/outbound2`;
            options.types.external.tokenExchangeUrl = `https://localhost.troweprice.com:8080${GLOBALS.AAM_UI_TRP_APP_CONTEXT}/api/token-exchange-service/service/token`;
            options.types.external.authorizeUrl = `https://localhost.troweprice.com:8080${GLOBALS.AAM_UI_TRP_APP_CONTEXT}/api/v0/ciam-public/me`;
            options.types.external.echoUrl = {
                host: 'localhost.troweprice.com:8080',
                path: '/api/echo'
            };
        }

        return (
            <ErrorBoundary name="auth-provider">
            <AuthServiceProvider context={otelContext} options={options}>
                <AuthGate
                unauthenticated={() => (
                    <Redirect
                    href={`${GLOBALS.AAM_UI_EXTERNAL_BASE_URL}/usis/login?pdurl=${aamPdurl}sdurl=${aamSdurl}`}
                    />
                )}
                loading={() => (
                    <PageLoadingSpinner name="User Settings..." />
                )}
                >
                <SessionTimer/>
                <ErrorBoundary>
                    <div>{children}</div>
                </ErrorBoundary>
                </AuthGate>
            </AuthServiceProvider>
            </ErrorBoundary>
        )
    }}
    </ConfigContext.Consumer>
  );
};

const mapStateToProps = (state) => {
  return {
    accounts: getAccounts(state)
  };
};

export default withRouter(
    compose(
        connect(mapStateToProps),
        withAuthState
    )(SecureAuth)
);
